import React from "react";
import { Modal, Button } from "react-bootstrap";

const DthInfoModal = ({ show, onClose, info }) => {
  if (!info) return null;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>DTH Customer Info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {info.customer_name}
        </p>
        <p>
          <strong>Balance:</strong> ₹{info.balance}
        </p>
        <p>
          <strong>Status:</strong> {info.status}
        </p>
        <p>
          <strong>Next Recharge Date:</strong> {info.next_recharge_date}
        </p>
        <p>
          <strong>Monthly Recharge:</strong> ₹{info.monthly_recharge}
        </p>
        <p>
          <strong>Plan:</strong>
          <br />
          {info.plan_name}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DthInfoModal;
